import { Ticket } from 'types/User/firebaseTypes/ticket';

/** Return array of tickets where the ticketTrigger is currently an active filter. */
export const filterByIssueCause = (
    filters: Record<string, boolean>,
    allTickets: Ticket[]
): Ticket[] => {
    const filteredTickets: Ticket[] = [];
    allTickets.forEach((ticket: Ticket) => {
        if (filters[ticket.ticketTrigger] === true) {
            filteredTickets.push(ticket);
        }
    });
    return filteredTickets;
};
